import { api } from 'api'
import { Pagination } from 'interfaces/api.interfaces'
import { UpdateAlertParams } from 'interfaces/store/alertManual.interfaces'
import { createAsyncThunk } from 'modules/store'

export const getAllAlertManuals = createAsyncThunk(
  'alertManuals/getAll',
  async (params: Partial<Pagination>, { rejectWithValue }) =>
    api.alertManual.getAll(params).catch((error) => rejectWithValue(error.message)),
)

export const updateAlertManual = createAsyncThunk(
  'alertManuals/update',
  async (params: UpdateAlertParams, { rejectWithValue }) =>
    api.alertManual
      .update(params.alertManual)
      .then(() => {
        params.onSuccess?.()
      })
      .catch((error) => rejectWithValue(error.message)),
)
